import React from 'react';
import PDFDownloadButton from './PDFDownloadButton';

const SectionHeader = ({ title, pdfData, pdfFilename, pdfTitle, pdfTableHeaders }) => {
    return (
        <div className="section-header">
            <h3>{title}</h3>
            {pdfData && (
                <PDFDownloadButton
                    data={pdfData}
                    filename={pdfFilename}
                    caption={pdfTitle || title}
                    tableHeaders={pdfTableHeaders}
                />
            )}
        </div>
    );
};

export default SectionHeader;
